export const LogoMark = ({ className = "w-9 h-9" }) => (
  <svg viewBox="0 0 64 64" fill="none" className={className} aria-hidden="true">
    <defs>
      <linearGradient id="adriatica-gold" x1="8" y1="56" x2="56" y2="8" gradientUnits="userSpaceOnUse">
        <stop stopColor="#9A7B2C" />
        <stop offset="0.5" stopColor="#D4AF37" />
        <stop offset="1" stopColor="#F3E08B" />
      </linearGradient>
    </defs>
    <path d="M10 56V26L32 8l22 18v30" stroke="url(#adriatica-gold)" strokeWidth="4" strokeLinejoin="round" />
    <path d="M23 56V36l9-7 9 7v20" stroke="url(#adriatica-gold)" strokeWidth="4" strokeLinejoin="round" />
    <line x1="32" y1="8" x2="32" y2="20" stroke="url(#adriatica-gold)" strokeWidth="4" />
  </svg>
);

export const LogoLockup = ({ compact = false }) => (
  <span className="flex items-center gap-3">
    <LogoMark className={compact ? "w-8 h-8" : "w-10 h-10"} />
    <span className="flex flex-col leading-none">
      <span className="font-display tracking-[0.22em] text-white text-base sm:text-lg">ADRIATICA</span>
      <span className="text-[9px] tracking-[0.3em] text-[#D4AF37] uppercase mt-1">S.r.l. Semplificata</span>
    </span>
  </span>
);
